export function storeAsJson(key: string, obj: any) {
    localStorage.setItem(key, JSON.stringify(obj));
}

export function keyExist(key: string) {
    var item = localStorage.getItem(key);
    return typeof(item) != "undefined" && item != null;
}

export function removeItem(key: string) {
    localStorage.removeItem(key);
}

export function getJsonAsObject<T>(key: string): T {
    return JSON.parse(localStorage.getItem(key)) as T;
}

export function getItem(key: string): string {
    return localStorage.getItem(key);
}


// WEBPACK FOOTER //
// ./src/app/utils/LocalStorageUtils.ts